module.exports = __webpack_public_path__ + "static/GPS-11fff99ba1c0dd4a279c6fc668bd7cc2.png";